import { SuperAdminService } from "services/superAdminService";

class AmalsSAService extends SuperAdminService<any> {
  constructor() {
    super("amals");
  }
}
export default new AmalsSAService();
